import { Button } from "@ui/components/forms/button/Button";
import { Flex } from "@ui/components/layout/flex/Flex";
import { NextImage } from "@ui/components/media-and-icons/image/NextImage";
import { memo } from "react";
import type { Image } from "@graphql/generated/types";

type ProductImageThumbnailProps = {
    index: number;
    currentlySelected: boolean;
    image: Image;
    setImageIndex: (index: number) => void;
    alt: string;
};

export const ProductImageThumbnail = memo(
    ({ index, currentlySelected, image, setImageIndex, alt }: ProductImageThumbnailProps) => {
        const beforePseudoElementStyles = {
            content: "''",
            position: "absolute",
            left: "0",
            bottom: "0",
            width: "100%",
            height: "1.7px",
            backgroundImage: " linear-gradient(#000,#000)",
            transition: "transform .2s ease-in-out",
            willChange: "transform",
            transformOrigin: "left bottom",
        };

        return (
            <Flex
                as={Button}
                variant={"unstyled"}
                key={image.url}
                h={["100%", "100%"]}
                px={[0, 0, 0, 0]}
                onClick={() => setImageIndex(index)}
                //@TODO: Intl of labels.
                aria-label={`Product image ${image.label ?? index}`}
                sx={{
                    " &::before": {
                        ...beforePseudoElementStyles,
                        transform: currentlySelected ? "scaleX(1)" : "scaleX(0)",
                    },
                    order: index === 0 ? 0 : index + 1,
                }}
            >
                <NextImage
                    layout="fill"
                    objectFit={"cover"}
                    src={image.url}
                    sx={{
                        aspectRatio: "2/3",
                    }}
                    sizes={["5vw"]}
                    quality={50}
                    alt={alt}
                />
            </Flex>
        );
    }
);

ProductImageThumbnail.displayName = "ProductImageThumbnail";
